import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { HeaderService } from '../services/header.service';
import { WorkspaceService } from '../services/workspace.service';
import { ThemeSetting } from '../objects/ThemeObject';
import { ThemeSettingService } from '../services/theme-setting.service';
import { SummaryService } from '../services/summary.service';

@Component({
  selector: 'app-broadcast',
  templateUrl: './broadcast.component.html',
  styleUrls: ['./broadcast.component.css']
})
export class BroadcastComponent implements OnInit {

  @Input() detailId: string;
  @Input() broadcastAction: string;
  @Input() docType: string;
  @Input() docId: string;
  @Input() type: string;
  @Input() title: string;
  @Input() color: string;

  @Output() returnObject = new EventEmitter<any>();

  @ViewChild('input') public input: ElementRef;

  opened: boolean = false;
  forceRefresh: boolean = false;
  isBusy: boolean = false;
  loaderConfig: any;
  hasNew: boolean = false;

  constructor(private workspaceService:WorkspaceService, private themeSettingService: ThemeSettingService, private summaryService: SummaryService) {
    this.summaryService.hasNewMessagesChanged$.subscribe(result => {
      this.setHasNew(result);
    })
   }

  ngOnInit() {
    let themes:ThemeSetting = this.themeSettingService.getTheme();
    this.loaderConfig = themes;
  }

  submit(message: string){
    if (message){
      this.isBusy = true;
      var param = [];
      param.push({ name: 'DocType', value: this.docType });
      param.push({ name: 'DocId', value: this.docId });
      param.push({ name: 'Message', value: message });

      this.workspaceService.executeGenericWorkflow(this.broadcastAction, param).subscribe(result =>{
        var resultObject = JSON.parse(result);
        this.isBusy = false;
        this.input.nativeElement.value = "";
        this.returnObject.emit(result);

        switch(resultObject.RefreshType){
          case "self": this.forceRefresh = !this.forceRefresh; break;
          case "parent":
            this.forceRefresh = !this.forceRefresh;
            this.getEPICParent(false, resultObject.ReturnType);
            break;
          case "all":
            this.forceRefresh = !this.forceRefresh;
            this.getEPICParent(true, resultObject.ReturnType);
          break;
        }
      }, error => {
        this.isBusy = false;
      });
    }
  }

  getEPICParent(findAllParent:boolean, returnType:number){
    if (findAllParent){
      this.workspaceService.getAllParentsEPICId(this.detailId).subscribe(result => {
        if (result){
          var array = JSON.parse(result);
          array.forEach(id => {
            this.workspaceService.setParentId(id);
          });
        }
      })
    }
    else{
      this.workspaceService.getParentEPICId(this.detailId).subscribe(result => {
        this.workspaceService.setParentId(result);
      })
    }
  }

  setHasNew(bool: boolean){
    if (!this.opened){
      this.hasNew = bool;
    }
  }

  togglePopover(pre: boolean){
    this.opened = pre;
    if (this.opened){
     this.hasNew = false; 
    }
  }

}
